import { useLayoutEffect, useMemo, useRef } from "react";

import { FoodItem } from "../../../types";
import Loader from "../Loader";
import { SingleFoodItem } from "../FoodItem";
import { motion } from "framer-motion";
import NotFound from "../NotFound"; 
import { useStateValue } from "../../context/StateProvider";

const Container = ({scrollOffset, col, items, className }: {scrollOffset:number, col?: boolean; items: FoodItem[], className?:string }) => { 
  
  const [{ products, categories }] = useStateValue();

  // Built once here rather than per card: with several hundred items on screen
  // each one rebuilding the same lookup would be wasted work.
  const categoryNameByType = useMemo(() => {
    const map: Record<string, string> = {};
    (categories || []).forEach((c: any) => {
      if (c?.categoryType) map[c.categoryType] = String(c.title || "").trim();
    });
    return map;
  }, [categories]);
  const containerRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if(null !== containerRef.current){
      containerRef.current.scrollLeft += scrollOffset
    }
  }, [scrollOffset]);
  return (
    <motion.div
      ref = {containerRef}
      initial={{ opacity: 0, x: 200 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 200 }}
      className={`${className} w-full my-12 flex items-center ${(!items || col) && "justify-center"}   min-h-[200px] gap-4  px-2 ${
        !col ? "overflow-x-scroll scrollbar-hidden scroll-smooth" : "overflow-x-hidden flex-wrap"
      }`}
    >
      {items  && items.map((item: FoodItem) => (
        <SingleFoodItem
          key={item.id}
          item={item}
          col={col}
          categoryName={categoryNameByType[(item as any).category]}
        />
      ))} 
      { 
       !products ? (<Loader progress = {"Loading Food Items....."} />) :  items?.length <= 0 &&  (<NotFound text="No items found..."  />)
      } 
    </motion.div>
  );
};

export default Container;
